import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::storybook'

export default pipe(
  modelComposition(descriptor),
)
